import React from 'react';
import { ChipInput as ChipInputNew } from './ChipInput';
import { convertOldChipInputProps } from './converter.old';
import type { OldChipInputProps, OldChipInputValue } from './converter.old';

export type ChipInputValue = OldChipInputValue;
export type ChipInputProps = OldChipInputProps;

export const ChipInput = React.forwardRef<HTMLInputElement, ChipInputProps>((props, ref) => (
  <ChipInputNew {...convertOldChipInputProps(props)} ref={ref} />
));
